/* eslint-disable no-console */
import { CubeTextureLoader, type TextureLoader } from 'three';
import { type DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import 'url-search-params-polyfill';

const isBrowser = () => typeof window !== 'undefined';

export const isTouchDevice = () => {
    return navigator
        ? 'ontouchstart' in window ||
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore-disable-next-line
              (window.DocumentTouch && document instanceof window.DocumentTouch) ||
              navigator.maxTouchPoints ||
              false
        : false;
};

export const getSearchParam = (param: string, getValue = false): boolean | string | null => {
    if (!isBrowser()) return false;
    const queryString = window.location.search.toLowerCase();
    const urlParams = new URLSearchParams(queryString);
    const paramType = urlParams.has(param);
    const paramValue = urlParams.get(param);
    return urlParams.has('debug') && (getValue ? paramValue : paramType);
};

interface asyncLoaderParams {
    dracoLoader?: DRACOLoader | null;
    files?: string[];
}

export const asyncLoader = (
    url: string,
    loader: TextureLoader | CubeTextureLoader | GLTFLoader,
    params?: asyncLoaderParams,
) => {
    return new Promise((resolve) => {
        if (loader instanceof GLTFLoader) {
            if (params) {
                const { dracoLoader } = params;
                if (dracoLoader) {
                    dracoLoader.setDecoderConfig({ type: 'js' });
                    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
                    loader.setDRACOLoader(dracoLoader);
                }
                loader.load(
                    url,
                    (data) => {
                        return resolve(data);
                    },
                    // called while loading is progressing
                    () => {
                        return;
                    },
                    // called when loading has errors
                    (error) => {
                        // eslint-disable-next-line no-console
                        console.warn(error);
                    },
                );
            }
        } else {
            if (loader instanceof CubeTextureLoader) {
                if (!params || !params.files) return;
                loader.setPath(url).load(params.files, (data) => {
                    return resolve(data);
                });
            } else {
                loader.load(
                    url,
                    (data) => {
                        return resolve(data);
                    },
                    // called while loading is progressing
                    () => {
                        return;
                    },
                    // called when loading has errors
                    (error) => {
                        // eslint-disable-next-line no-console
                        console.warn(url);
                        // eslint-disable-next-line no-console
                        console.warn(error);
                        return resolve(false);
                    },
                );
            }
        }
    });
};

export const waitForNextFrame = () => {
    return new Promise<void>((resolve) => {
        requestAnimationFrame(() => {
            resolve();
        });
    });
};
